module.exports = __webpack_public_path__ + "static/media/globe.8a0f917b.svg";